import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { MenuBook as SourceIcon } from '@mui/icons-material';
import type { Source } from '../types/api';

export interface SourceBadgeProps {
  source: Source;
  onClick?: (sourceId: number) => void;
}

const SourceBadge: React.FC<SourceBadgeProps> = ({ source, onClick }) => {
  const handleClick = () => {
    if (onClick) {
      onClick(source.id);
    }
  };

  return (
    <Tooltip title={source.name} enterDelay={200} arrow>
      <Chip
        icon={<SourceIcon sx={{ fontSize: '0.875rem' }} />}
        label={source.name}
        size="small"
        variant="outlined"
        onClick={handleClick}
        sx={{
          maxWidth: 150,
          cursor: 'pointer',
          fontSize: '0.75rem',
          height: 24,
          '& .MuiChip-label': {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            px: 0.5,
          },
          '& .MuiChip-icon': {
            ml: 0.5,
          },
          '&:hover': {
            backgroundColor: 'action.hover',
          },
        }}
      />
    </Tooltip>
  );
};

export default SourceBadge;
